<!--
 * @Description: 首页
-->
<template>
  <div class="home">
    <van-nav-bar v-show="$topBar" :title="$route.meta.title" fixed>
    </van-nav-bar>
    <div v-show="$topBar" class="comm-topbar-height"></div>
    <van-swipe class="my-swipe" :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>
    <van-notice-bar left-icon="volume-o" :scrollable="false" v-if="noticeList.length>0" class="small-notice" background="#ffffff" color="rgba(153,153,153,1)" v-show="false">
      <template #left-icon>
        <span class="iconfont icongonggao" style="color:#258A37;"></span>
      </template>
      <van-swipe vertical class="notice-swipe" :autoplay="5000" :show-indicators="false" style="margin-left:10px;">
        <van-swipe-item v-for="(notice, i) in noticeList" :key="i">
          {{notice.tit}}
        </van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <van-grid style="margin-top:10px;" :column-num="4" :border="false">
      <van-grid-item v-for="(menu, i) in homeMenus" :key="i" icon="photo-o" :text="menu.name" @click="menuClick(menu)">
        <div slot="default">
          <!-- :style="{opacity:menu.name=='智水中心'?0.5:1}" -->
          <div class="my-grid">
            <div class="my-grid-icon" :style="{color: menu.color}">
              <span class="iconfont" :class="menu.icon"></span>
            </div>
            <div class="my-grid-txt">{{menu.name}}</div>
          </div>
        </div>
      </van-grid-item>
    </van-grid>
    <div class="belt">
      <img @click="businessImgClick()" v-lazy="require('../../assets/images/business.png')" />
      <img @click="butlerImgClick()" v-lazy="require('../../assets/images/butlernew.png')" />
    </div>
    <div class="home-title">办事指南</div>
    <van-grid style="margin-top:-7px;" :column-num="4" :border="false">
      <van-grid-item v-for="(menu, i) in guideMenus" :key="i" icon="photo-o" :text="menu.name" @click="menuClick(menu)">
        <div slot="default">
          <div class="my-grid" :style="{opacity:menu.path===''?0.5:1}">
            <div class="my-grid-icon" :style="{
                'background': menu.color,
                'color': '#ffffff',
                'border-radius': '50%',
                'height': '48px',
                'line-height': '48px',
                'text-align': 'center'
              }">
              <span class="iconfont" :class="menu.icon" style="font-size:32px;">
              </span>
            </div>
            <div class="my-grid-txt" style="margin-top:4px;">{{menu.name}}</div>
          </div>
        </div>
      </van-grid-item>
    </van-grid>
    <div class="home-title">业务常识</div>
    <van-grid style="margin-top:-7px;" :column-num="4" :border="false">
      <van-grid-item v-for="(menu, i) in nousMenus" :key="i" icon="photo-o" :text="menu.name" @click="menuClick(menu)">
        <div slot="default">
          <div class="my-grid" :style="{opacity:menu.path===''?0.5:1}">
            <div class="my-grid-icon" :style="{
                'background': menu.color,
                'color': '#ffffff',
                'border-radius': '50%',
                'height': '48px',
                'line-height': '48px',
                'text-align': 'center'
              }">
              <span class="iconfont" :class="menu.icon" style="font-size:32px;"></span>
            </div>
            <div class="my-grid-txt" style="margin-top:4px;">{{menu.name}}</div>
          </div>
        </div>
      </van-grid-item>
    </van-grid>
    <div class="van-grid" style="font-size:12px;">
      <div class="beian">
        <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">公安备案号：贵公网安备52039002001389号</a>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">黔ICP备18007241号-4</a>
      </div>
    </div>

    <div style="height:7px;width:100%;"></div>
    <div class="comm-homebar-height"></div>
    <home-bar></home-bar>
  </div>
</template>

<script>
import HomeBar from '@/components/HomeBar.vue'
import Api from '../../lib/api'
import Http from '../../lib/http'
import common from '../../lib/common'

export default {
  name: 'Home',
  data() {
    return {
      noticeList: [],
      mobile: '',
      images: [require('../../assets/images/hall-blue.png')],
      homeMenus: [
        {
          name: '水费缴纳',
          icon: 'iconfeiyongjiaocha',
          color: '#00B878',
          path: '/pay/feePay',
        },
        {
          name: '水费查询',
          icon: 'iconshuifeiqingdan1',
          color: '#2881FF',
          path: '/pay/feeList',
        },
        {
          name: '业务办理进度查询',
          icon: 'iconshoulijindu',
          color: '#FF943E',
          path: 'mine/businessProgress?active=0',
        },
        // {
        //   name: '户号查询',
        //   icon: 'iconhuhaochaxun',
        //   color: '#32A246',
        //   path: '/mine/codeBind?active=1'
        // },
        {
          name: '户号绑定',
          icon: 'iconhuhaobangding',
          color: '#FCA916',
          path: '/mine/codeBind?active=0',
        },
        {
          name: '非居民污水处理费缓交申请',
          icon: 'iconjindu',
          color: '#FF943E',
          path: '/butler/paysewage',
        },
      ],
      guideMenus: [
        {
          name: '业务须知',
          icon: 'iconyewuxuzhi',
          color: '#00B878',
          path: '/guide/mustKnow?active=0',
        },
        {
          name: '营业网点',
          icon: 'iconyingyewangdian',
          color: '#8659C8',
          path: '/guide/mustKnow?active=1',
        },
        {
          name: '缴费方式',
          icon: 'iconjiaofeifangshi',
          color: '#FCA916',
          path: '/guide/mustKnow?active=2',
        },
        {
          name: '现行水价',
          icon: 'iconxianhangshuijia',
          color: '#2881FF',
          path: '/guide/mustKnow?active=3',
        },
      ],
      nousMenus: [
        {
          name: '常见问题',
          icon: 'iconchangjianwenti',
          color: '#FCA916',
          path: '/home/faq?active=0',
        },
        {
          name: '政策法规',
          icon: 'iconfagui',
          color: '#FC5F12',
          path: '/home/faq?active=1',
        },
        {
          name: '行业标准',
          icon: 'iconhangyebiaozhun',
          color: '#32A246',
          path: '/home/faq?active=2',
        },
        {
          name: '服务承诺',
          icon: 'iconfuwuchengnuo',
          color: '#2881FF',
          path: '/home/faq?active=3',
        },
      ],
    }
  },
  components: {
    HomeBar,
  },
  mounted() {
    //检查token是否过期
    this.gettoken()
    // //清理缓存，重新获取数据
    // if (localStorage.getItem('initdata') != "4") {
    //   localStorage.setItem('initdata', "0");
    //   localStorage.clear();
    //   localStorage.setItem('initdata', "4");
    // }
    // //获取用户信息
    // if ((!localStorage.getItem('access_token') || !localStorage.getItem("cuser_info"))) {
    //   let code = common.GetQueryString('code');
    //   localStorage.setItem("code", code);
    //   if (code && code !== '') {
    //     this.getUserInfo(code);
    //   }
    // }
    //更新用户信息
    let cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
    if (cuser_info == null || cuser_info == undefined || cuser_info.uid == '' || cuser_info.uid == '0') {
      this.updateuserinfo()
    }
  },
  methods: {
    getUserInfo(code) {
      localStorage.clear()
      let apiurl = Api.getOauth2
      Http.get(apiurl, {
        code: code,
      }).then((res) => {
        if (res.code === '000') {
          let access_token = res.data.access_token
          let refresh_token = res.data.refresh_token
          let token = res.data.token
          let nickname = res.data.nickname
          let avatar = res.data.avatar

          if (access_token) {
            // 已注册，更新token
            localStorage.setItem('access_token', access_token)
            localStorage.setItem('refresh_token', refresh_token)
            localStorage.setItem('token', token)
            localStorage.setItem('nickname', nickname)
            localStorage.setItem('avatar', avatar)
            localStorage.setItem('cuser_info', JSON.stringify(res.data))
            localStorage.setItem('initdata', '4') //标志
          }
          //获取绑定用户
          Http.post(Api.userList, {}).then((res) => {
            if (res.code === '000') {
              if (res.data != null && res.data.length > 0) {
                // 已绑定
                localStorage.setItem('userList', JSON.stringify(res.data))
              }
            }
          })
        }
      })
    },
    updateuserinfo() {
      this.$http.post(this.$api.userUpdate, {}).then((res) => {
        if (res.code === '000') {
          localStorage.setItem('access_token', res.data.access_token)
          localStorage.setItem('refresh_token', res.data.refresh_token)
          localStorage.setItem('nickname', res.data.nickname)
          localStorage.setItem('avatar', res.data.avatar)

          let cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
          cuser_info.uid = res.data.uid
          cuser_info.uname = res.data.uname
          cuser_info.nickname = res.data.nickname
          cuser_info.mobile = res.data.mobile
          cuser_info.access_token = res.data.access_token
          cuser_info.refresh_token = res.data.refresh_token
          localStorage.setItem('cuser_info', JSON.stringify(cuser_info))
          localStorage.setItem('initdata', '4') //标志
        }
      })
    },
    gettoken() {
      this.$http.post(this.$api.getToken, {}).then((res) => {
        if (res.code === '003') {
          let code = this.$comm.GetQueryString('code')
          this.$http
            .get(this.$api.getOauth2, { code: code })
            .then((res) => {
              if (res.code === '000') {
                let access_token = res.data.access_token
                let refresh_token = res.data.refresh_token
                let nickname = res.data.nickname
                let avatar = res.data.avatar
                if (access_token) {
                  localStorage.setItem('access_token', access_token)
                  localStorage.setItem('refresh_token', refresh_token)

                  localStorage.setItem('nickname', nickname)
                  localStorage.setItem('avatar', avatar)
                  localStorage.setItem('cuser_info', JSON.stringify(res.data))
                }
              } else {
                this.$toast(res.msg)
              }
            })
            .catch((e) => {
              this.$toast(e.message)
            })
        }
      })
    },
    getNotice() {
      this.$http.post(this.$api.getNotice, {}).then((res) => {
        if (res.code === '000') {
          this.noticeList = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    businessImgClick() {
      this.$router.push('/business')
    },
    butlerImgClick() {
      this.$router.push('/butler')
    },
    menuClick(menu) {
      if (menu.name == '水费查询') {
        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2b4a0f1a0079b7b4&redirect_uri=http%3A%2F%2Fwww.xqgsys.com%2Fwechat-xp%2Fapi%2Fweixin%2Fhhbd%2FhblfIntro%3FwxId%3Da5c855b32554a8d2a57e382913f71a35&response_type=code&scope=snsapi_base#wechat_redirect'
        return
      }
      if (menu.name == '水费缴纳') {
        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2b4a0f1a0079b7b4&redirect_uri=http%3A%2F%2Fwww.xqgsys.com%2Fwechat-xp%2Fapi%2Fweixin%2Fhhbd%2FyhjsfIntro%3FwxId%3Da5c855b32554a8d2a57e382913f71a35&response_type=code&scope=snsapi_base#wechat_redirect'
        return
      }
      this.$router.push({
        path: menu.path,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.home {
  .my-swipe {
    img {
      width: 100%;
      height: 141.5px;
    }
  }
  .small-notice {
    margin: 0 16px;
    height: 32px;
    margin-top: -19px;
    border-radius: 16px;
  }
  .notice-swipe {
    height: 40px;
    line-height: 40px;
  }
  .my-grid {
    text-align: center;
    .my-grid-icon {
      // height: 28px;
      .iconfont {
        font-size: 48px;
      }
    }
    .my-grid-txt {
      // margin-top: 15px;
      height: 32px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 33, 33, 1);
    }
  }
  .belt {
    margin-top: 7px;
    // height: 124px;
    padding: 12px 16px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 47.5%;
      // height: 100px;
    }
  }
  .home-title {
    margin-top: 7px;
    height: 39px;
    background: #ffffff;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: rgba(33, 33, 33, 1);
    line-height: 39px;
    padding-left: 16px;
  }
}
/deep/ .van-grid {
  background: white !important;
}
.beian {
  width: 100%;
  text-align: center;
  color: #939393;
  padding-bottom: 12px;
  a {
    text-decoration: none;
    display: block;
    &:visited {
      color: inherit;
    }
    & + a {
      margin-top: 8px;
    }
  }
}
</style>
